import { X } from 'lucide-preact'
import type { OnlineEventSpeakerViewDto } from '@/api/webs'

interface Props {
    speaker: OnlineEventSpeakerViewDto
    deleting: boolean
    onClose: () => void
    onConfirm: () => void
}

export function DeleteSpeakerModal({ speaker, deleting, onClose, onConfirm }: Props) {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm" onClick={() => !deleting && onClose()} />
            <div className="relative w-full max-w-md rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-xl p-6 flex flex-col gap-4">
                <div className="flex items-start justify-between gap-4">
                    <div>
                        <h4 className="text-base font-semibold text-slate-900 dark:text-white">Remove Participant</h4>
                        <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">This will permanently remove <span className="font-medium">{speaker.Name}</span> from this event.</p>
                    </div>
                    <button type="button" onClick={() => !deleting && onClose()} className="p-2 rounded-md hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-500 dark:text-slate-300" aria-label="Close" title="Close"><X className="w-4 h-4" /></button>
                </div>
                <div className="flex flex-col gap-2 text-xs bg-slate-50 dark:bg-slate-900/40 border border-slate-200 dark:border-slate-700 rounded-md p-3">
                    <div><span className="font-medium text-slate-700 dark:text-slate-300">Email:</span> <span className="text-slate-600 dark:text-slate-400">{speaker.Email}</span></div>
                    {speaker.CompanyName && <div><span className="font-medium text-slate-700 dark:text-slate-300">Company:</span> <span className="text-slate-600 dark:text-slate-400">{speaker.CompanyName}</span></div>}
                    {speaker.Title && <div><span className="font-medium text-slate-700 dark:text-slate-300">Title:</span> <span className="text-slate-600 dark:text-slate-400">{speaker.Title}</span></div>}
                </div>
                <div className="flex items-center justify-end gap-3 mt-2">
                    <button type="button" disabled={deleting} onClick={onClose} className="px-3 py-1.5 text-sm rounded-md border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700 disabled:opacity-50">Cancel</button>
                    <button type="button" disabled={deleting} onClick={onConfirm} className="inline-flex items-center gap-2 px-3 py-1.5 text-sm rounded-md bg-red-600 text-white hover:bg-red-700 disabled:opacity-50">{deleting ? 'Removing...' : 'Yes, Remove'}</button>
                </div>
            </div>
        </div>
    )
}
